import {scheduleDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {useMobileFontOverrides} from '../../../../../../commons/hooks/use-mobile-font-overrides'
import {useSettings} from '../../../../hooks/settings'
import {useVisibilityStyles} from '../../../../hooks/use-visibility-styles'
import settingsParams from '../../../../settingsParams'
import {useWidgetProps} from '../../../hooks/widget-props'
import {PersonalAgendaHeader} from '../personal-agenda-header'
import s from './mobile-header.scss'
import {MobileHeaderProps} from '.'

export const MobileHeader = ({alignmentClass}: MobileHeaderProps) => {
  const {eventTitle, formattedEventDateAndLocation, installedApps, personalAgendaEnabled} = useWidgetProps()
  const settings = useSettings()
  const {
    allBreakpoints: {isDateAndLocationVisible},
  } = useVisibilityStyles()
  const {mobileFontOverridesEnabled} = useMobileFontOverrides()

  return (
    <div className={alignmentClass}>
      {personalAgendaEnabled ? <PersonalAgendaHeader membersAreaInstalled={installedApps.membersArea} /> : null}
      <h1
        className={classNames(s.titleMobile, {[s.mobileFontSize]: mobileFontOverridesEnabled})}
        data-hook={DH.SCHEDULE_TITLE}
      >
        {settings.get(settingsParams.scheduleTitleText)}
      </h1>
      {isDateAndLocationVisible() ? (
        <div className={classNames(s.dateLocationMobile, {[s.mobileFontSize]: mobileFontOverridesEnabled})}>
          <span data-hook={DH.EVENT_TITLE}>{`${eventTitle} | `}</span>
          <span>{formattedEventDateAndLocation}</span>
        </div>
      ) : null}
    </div>
  )
}
